import { render } from "./TuitionPriceListsContent.vue?vue&type=template&id=1d2fa9da&ts=true"
import script from "./TuitionPriceListsContent.vue?vue&type=script&lang=ts"
export * from "./TuitionPriceListsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__